import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_DASHBOARD_HUS

export default class Contratos {
  getContratos (payload = {}) {
    return http.get(`${baseUrl}/operaciones/contratos`, {
      params: payload,
      headers: {
        loading: true
      }
    })
  }
}
